import React from 'react'; 
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'swiper/css';
import 'swiper/css/pagination';


function Footer() {

    return(
<footer className="bg-gray-900 text-white py-6 pppp">
<div className="container mx-auto grid grid-cols-1 md:grid-cols-3 gap-4 text-center md:text-left">

  <div>
    <h4 className="text-lg font-semibold mb-2">Quick Links</h4>
    <ul className="space-y-1">
      <li><a href="/" className="hover:text-teal-600">Home</a></li>
      <li><a href="/about" className="hover:text-teal-600">About Us</a></li>
      <li><a href="#services" className="hover:text-teal-600">Services</a></li>
      
      <li><a href="/equipmentrent" className="hover:text-teal-600">Medical Equipment</a></li>
      <li><a href="/teamofdoctors" className="hover:text-teal-600">Team of Doctors</a></li>
      <li><a href="/contact" className="hover:text-teal-600">Contact Us</a></li>
    </ul>
  </div>


  <div>
    <h4 className="text-lg font-semibold mb-2">Contact Info</h4>
    <p className="mb-1"><strong>Prince Bhardwaj:</strong> <a href="tel:+919910967118" className="hover:text-teal-600">+91 9910967118</a></p>
    <p className="mb-1"><strong>Bhagat singh:</strong> <a href="tel:+919910967118" className="hover:text-teal-600">+91 9910967118</a></p>

    <p className="mb-1"><strong>Email:</strong> <a href="mailto:info@guardianscare.com" className="hover:text-teal-600">info@guardianscare.com</a></p>
  </div>


  <div>
    <h4 className="text-lg font-semibold mb-2">Our Address</h4>
    <p>Healthcare St,</p>
    <p>Chinchwad,</p>
    <p>Pune, Maharashtra</p>
  </div>
</div>


<div className="text-center mt-6 LLLL">
  <p>&copy; 2024 Guardians Home Care. All rights reserved.</p>
</div>
</footer>
    );
}
export default Footer;
